import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { ReqBskRoutes } from './reqbsk.routes';
import { ListReqBskComponent } from './list-reqbsk/list-reqbsk.component';
import { FormReqBskComponent } from './_components/form-reqbsk/form-reqbsk.component';
import { AddReqBskComponent } from './add-reqbsk/add-reqbsk.component';
import { EditReqBskComponent } from './edit-reqbsk/edit-reqbsk.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    imports: [
        ReqBskRoutes,
        SharedDocumalisModule,
        TranslateModule,
        FormReqBskComponent,
    ],
    declarations: [
        ListReqBskComponent,
        AddReqBskComponent,
        EditReqBskComponent
    ]
})
export class ReqBskModule { }
